import { cn } from "~/lib/utils";

import type { FeatureProductCardSkeletonProps } from "./types";

/**
 * Loading stand-in shaped like `FeatureProductCard` — square photo, two-line
 * title, two feature blocks, same padding — so the row doesn't jump when the
 * products land (the generic `ProductTileSkeleton` is far shorter).
 */
export function FeatureProductCardSkeleton({
  className,
}: FeatureProductCardSkeletonProps) {
  return (
    <div
      className={cn(
        "flex h-full w-full animate-pulse flex-col gap-[20px] bg-white p-[14px] sm:p-[20px]",
        className,
      )}
      aria-hidden="true"
    >
      <div className="aspect-square w-full bg-gray-01" />
      <div className="flex flex-col gap-[16px] sm:gap-[24px]">
        <div className="min-h-[42px] w-3/4 bg-gray-01 sm:min-h-[60px]" />
        <div className="flex flex-col gap-3">
          <div className="min-h-[90px] w-full bg-gray-01" />
          <div className="min-h-[90px] w-full bg-gray-01" />
        </div>
      </div>
    </div>
  );
}
